// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1YEb4","title":"AfterBackImages_title__38zER","images":"AfterBackImages_images__N7kkV"};